module.exports = __webpack_public_path__ + "img/template_4.e8e4bd5a.png";